import React, { useState } from "react";
import Modal from "@/components/Modal/Modal";
import { TextField, Box } from "@mui/material";

interface PunchOutReportModalProps {
  modalOpen: boolean;
  closeModal: () => void;
  onSubmit: (report: string) => void;
  width?: string;
}

const PunchOutReportModal: React.FC<PunchOutReportModalProps> = ({
  modalOpen,
  closeModal,
  onSubmit,
  width,
}) => {
  const [report, setReport] = useState("");
  const [reportError, setReportError] = useState("");

  const handleDone = () => {
    if (!report.trim()) {
      setReportError("Report cannot be empty");
      return;
    }
    onSubmit(report);
    setReport("");
    setReportError("");
    closeModal();
  };

  const handleCancel = () => {
    setReport("");
    setReportError("");
    closeModal();
  };

  return (
    <Modal
      modalOpen={modalOpen}
      closeModal={handleCancel}
      heading="Punch Out Report"
      saveButtonText="Done"
      width={width || "500px"}
      errorMessage={reportError}
      onSave={handleDone}
    >
      <Box display="flex" flexDirection="column" gap={2} mt={1}>
        <TextField
          label="Report"
          multiline
          rows={4}
          variant="outlined"
          value={report}
          onChange={(e) => setReport(e.target.value)}
          fullWidth
        />
      </Box>
    </Modal>
  );
};

export default React.memo(PunchOutReportModal);
